import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import logo from '../assets/images/logo.svg';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { faPhone } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function Header() {
    const { t, i18n } = useTranslation();
    const [menuOpen, setMenuOpen] = useState(false);
    const isArabic = i18n.language === 'ar';

    return (
        <header className="fixed top-0 bg-white z-[99999] shadow-md w-full">
            <div className='hidden xl:block'>
                <div className='flex justify-end px-[10px] lg:px-[150px] pt-[5px] gap-[20px] fixed end-0'>
                    <a href='tel://+97165699999' target='_blank' className='nc flex items-center gap-[10px] cursor-pointer'>
                        <span className='rounded-full bg-[#201B57] p-[5px] w-[28px] h-[28px] flex justify-center items-center'>
                            <FontAwesomeIcon icon={faPhone} className="text-md text-white" />
                        </span>
                        <div className='flex flex-col gap-[3px]'>
                            <h2 className='leading-[15px] text-xs'>{t('call_now')}</h2>
                            <h2 className='leading-[15px] text-xs' style={{ fontFamily: 'Time New Roman' }}>{t('num')}</h2>
                        </div>
                    </a>

                    <a href='https://wa.me/+97165699999' target='_blank' className='nc flex items-center gap-[10px] cursor-pointer'>
                        <FontAwesomeIcon icon={faWhatsapp} className="text-2xl text-[#0b0]" />
                        <div className='flex flex-col gap-[3px]'>
                            <h2 className='leading-[15px] text-xs'>{t('whatsapp')}</h2>
                            <h2 className='leading-[15px] text-xs' style={{ fontFamily: 'Time New Roman' }}>{t('num')}</h2>
                        </div>
                    </a>
                </div>
            </div>
            {/* Navbar */}
            <nav className="flex justify-between items-end px-6 md:px-[150px] h-[80px] pb-[15px]">
                {/* Logo */}
                <div>
                    <NavLink to='/'><img src={logo} alt="IGT" className="h-10" /></NavLink>
                </div>

                {/* Desktop Menu */}
                <ul className="hidden xl:flex flex-1 items-end justify-end gap-[30px] text-md capitalize ms-10 pe-[50px]">
                    <li><NavLink to='/about' className='nc'>{t('about')}</NavLink></li>
                    <li><NavLink to='/brands' className='nc'>{t('brands')} <span style={{ fontFamily: 'Arial' }}>{isArabic ? 'و' : '&'}</span> {t('partners')}</NavLink></li>
                    <li>
                        <NavLink to='/career' className='nc'>{t('career')}</NavLink>
                    </li>
                    <li><NavLink to='/services' className='nc'>{t('services')}</NavLink></li>
                    <li><NavLink to='/blog' className='nc pe-[30px]'>{t('blog')}</NavLink></li>
                    <li><NavLink to='/contact' className='text-[#d0a847] underline underline-offset-[5px]'>{t('contact')}</NavLink></li>
                </ul>

                {/* Language Switcher (both desktop & mobile) */}
                <div className="hidden xl:flex items-center gap-4 text-lg">
                    <span onClick={() => {
                        i18n.changeLanguage('en')
                        window.location.reload()
                    }} className={`cursor-pointer nc ${i18n.language === 'en' && 'underline underline-offset-[5px]'}`}>EN</span>
                    <span onClick={() => {
                        i18n.changeLanguage('ar')
                        window.location.reload()
                    }} className={`cursor-pointer nc ${i18n.language === 'ar' && 'underline underline-offset-[5px]'}`}>AR</span>
                </div>

                {/* Mobile Hamburger Icon */}
                <button
                    className="xl:hidden text-2xl"
                    onClick={() => setMenuOpen(true)}
                >
                    ☰
                </button>
            </nav>

            {/* Mobile Drawer */}
            <div
                className={`fixed top-0 ${isArabic ? 'right-0' : 'left-0'} h-full w-[80%] max-w-xs bg-white z-[100000] p-6 shadow-lg transform transition-transform duration-300 ${menuOpen ? 'translate-x-0' : isArabic ? 'translate-x-full' : '-translate-x-full xl:hidden'
                    }`}
            >
                <button className="text-xl mb-4" onClick={() => setMenuOpen(false)}>
                    ✕
                </button>
                <ul className="flex flex-col gap-6 text-lg ">
                    <li><NavLink className='nc' to='/about' onClick={() => setMenuOpen(false)}>{t('about')}</NavLink></li>
                    <li><NavLink className='nc' to='/brands' onClick={() => setMenuOpen(false)}>{t('brands')} <span style={{ fontFamily: 'Arial' }}>{isArabic ? 'و' : '&'}</span> {t('partners')}</NavLink></li>
                    <li><NavLink className='nc' to='/career' onClick={() => setMenuOpen(false)}>{t('career')}</NavLink></li>
                    <li><NavLink className='nc' to='/services' onClick={() => setMenuOpen(false)}>{t('services')}</NavLink></li>
                    <li><NavLink className='nc' to='/blog' onClick={() => setMenuOpen(false)}>{t('blog')}</NavLink></li>
                    <li><NavLink to='/contact' onClick={() => setMenuOpen(false)} className='text-[#d0a847] underline underline-offset-[5px]'>{t('contact')}</NavLink></li>
                    <li className="flex gap-4">
                        <span onClick={() => {
                            i18n.changeLanguage('en')
                            window.location.reload()
                        }} className={`cursor-pointer nc ${i18n.language === 'en' && 'underline underline-offset-[5px]'}`}>EN</span>
                        <span onClick={() => {
                            i18n.changeLanguage('ar')
                            window.location.reload()
                        }} className={`cursor-pointer nc ${i18n.language === 'ar' && 'underline underline-offset-[5px]'}`}>AR</span>
                    </li>
                </ul>
            </div>

            {/* Overlay when menu is open */}
            {menuOpen && (
                <div
                    className="fixed inset-0 bg-black/50 z-[99999]"
                    onClick={() => setMenuOpen(false)}
                />
            )}
        </header>
    );
}
